(function () {
  'use strict';

  var SAMPLER_VARIANT_ID = '53707124343102';
  var cartState = null;
  var cartRequest = null;

  var messages = {
    samplerAlreadyInCart: 'Limit one free mini sampler per order.',
    samplerNeedsEmptyCart: 'The free mini sampler must be ordered separately. Please empty your cart before adding it.',
    removeSamplerFirst: 'The free mini sampler must be ordered separately. Remove it before adding other products.',
    invalidCart: 'The free mini sampler must be the only item in your cart, with quantity 1.'
  };

  function normalizeId(value) {
    return String(value || '').split('/').pop();
  }

  function cartSummary(cart) {
    var summary = {
      samplerQuantity: 0,
      otherQuantity: 0
    };

    if (!cart || !Array.isArray(cart.items)) return summary;

    cart.items.forEach(function (item) {
      var quantity = Number(item.quantity || 0);
      if (normalizeId(item.variant_id || item.id) === SAMPLER_VARIANT_ID) {
        summary.samplerQuantity += quantity;
      } else {
        summary.otherQuantity += quantity;
      }
    });

    return summary;
  }

  function isInvalidSamplerCart(cart) {
    var summary = cartSummary(cart);
    return summary.samplerQuantity > 1 || (summary.samplerQuantity > 0 && summary.otherQuantity > 0);
  }

  function fetchCart() {
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        cartState = cart;
        updatePageControls();
        return cart;
      })
      .catch(function () {
        return cartState;
      })
      .finally(function () {
        cartRequest = null;
      });

    return cartRequest;
  }

  function getVariantId(form) {
    if (!form) return '';
    try {
      return normalizeId(new FormData(form).get('id'));
    } catch (error) {
      var input = form.querySelector('[name="id"]');
      return normalizeId(input && input.value);
    }
  }

  function getQuantityInput(form) {
    if (!form) return null;
    return form.querySelector('[name="quantity"]') ||
      (form.id ? document.querySelector('[name="quantity"][form="' + form.id + '"]') : null);
  }

  function forceQuantityOne(form) {
    var input = getQuantityInput(form);
    if (input) {
      input.value = '1';
      input.setAttribute('max', '1');
    }
  }

  function restrictionFor(variantId, cart) {
    var summary = cartSummary(cart);

    if (variantId === SAMPLER_VARIANT_ID) {
      if (summary.samplerQuantity > 0) return messages.samplerAlreadyInCart;
      if (summary.otherQuantity > 0) return messages.samplerNeedsEmptyCart;
      return '';
    }

    if (summary.samplerQuantity > 0) return messages.removeSamplerFirst;
    return '';
  }

  function showMessage(form, message) {
    document.querySelectorAll('[data-mini-sampler-restriction-message]').forEach(function (element) {
      element.remove();
    });

    var notice = document.createElement('p');
    notice.setAttribute('data-mini-sampler-restriction-message', '');
    notice.setAttribute('role', 'alert');
    notice.style.color = '#a12720';
    notice.style.margin = '10px 0';
    notice.style.fontWeight = '600';
    notice.textContent = message;

    if (form) {
      var button = form.querySelector('[type="submit"]');
      if (button && button.parentNode) {
        button.parentNode.insertBefore(notice, button);
      } else {
        form.appendChild(notice);
      }
    } else {
      window.alert(message);
    }

    notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function updatePageControls() {
    var summary = cartSummary(cartState);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var variantId = getVariantId(form);
      if (variantId === SAMPLER_VARIANT_ID) forceQuantityOne(form);

      var quantityInput = getQuantityInput(form);
      if (variantId === SAMPLER_VARIANT_ID && quantityInput) {
        quantityInput.setAttribute('max', '1');
        if (Number(quantityInput.value || 1) > 1) quantityInput.value = '1';
      }

      var quantityWrapper = quantityInput && quantityInput.closest('[data-quantity-selector]');
      var plusButton = quantityWrapper && quantityWrapper.querySelector('[data-increase-quantity]');
      if (variantId === SAMPLER_VARIANT_ID && plusButton) {
        plusButton.disabled = true;
        plusButton.setAttribute('aria-disabled', 'true');
        plusButton.setAttribute('title', messages.samplerAlreadyInCart);
      }

      var submitButton = form.querySelector('[type="submit"]');
      if (!submitButton) return;

      if (variantId === SAMPLER_VARIANT_ID && summary.samplerQuantity > 0) {
        submitButton.setAttribute('data-mini-sampler-limit-reached', 'true');
      } else {
        submitButton.removeAttribute('data-mini-sampler-limit-reached');
      }
    });
  }

  function handleCartAddSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!String(form.getAttribute('action') || '').includes('/cart/add')) return;

    if (form.dataset.miniSamplerRestrictionBypass === 'true') {
      delete form.dataset.miniSamplerRestrictionBypass;
      return;
    }

    var variantId = getVariantId(form);
    if (!variantId) return;

    if (variantId === SAMPLER_VARIANT_ID) forceQuantityOne(form);

    if (cartState) {
      var message = restrictionFor(variantId, cartState);
      if (message) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showMessage(form, message);
      }
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    var submitter = event.submitter;

    fetchCart().then(function (cart) {
      var message = restrictionFor(variantId, cart);
      if (message) {
        showMessage(form, message);
        return;
      }

      form.dataset.miniSamplerRestrictionBypass = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else {
        form.submit();
      }
    });
  }

  function handleQuantityInteraction(event) {
    var row = event.target.closest('[data-cart-item][data-variant-id="' + SAMPLER_VARIANT_ID + '"]');
    if (!row) return;

    if (event.target.closest('[data-increase-quantity]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(row.closest('form'), messages.samplerAlreadyInCart);
      return;
    }

    var input = event.target.closest('[data-quantity-input]');
    if (input && Number(input.value || 1) > 1) {
      input.value = '1';
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(row.closest('form'), messages.samplerAlreadyInCart);
    }
  }

  function handleCheckout(event) {
    var checkoutControl = event.target.closest('[name="checkout"], [href*="/checkout"], [data-checkout-button]');
    if (!checkoutControl || !isInvalidSamplerCart(cartState)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showMessage(checkoutControl.closest('form'), messages.invalidCart);
  }

  document.addEventListener('submit', handleCartAddSubmit, true);
  document.addEventListener('click', handleQuantityInteraction, true);
  document.addEventListener('change', handleQuantityInteraction, true);
  document.addEventListener('click', handleCheckout, true);

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      cartState = event.detail.cart;
      updatePageControls();
    }
  });

  document.addEventListener('theme:cart:init', function () {
    fetchCart();
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart();
    updatePageControls();
  });
})();
